import { render, staticRenderFns } from "./RecursosForm.vue?vue&type=template&id=c7dd5290&"
import script from "./RecursosForm.vue?vue&type=script&lang=js&"
export * from "./RecursosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports